/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { goToHomeHybridMod } from '@/navigation/CSR/goToHomeHybridMod'
import getLocale from '@/stores/locales'
import { getSimpleViewOptions } from '@/useCases/simpleViewOptions'
import isSSR from '@/utils/isSSR'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client/contexts'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { Button } from 'antd'
import { usePathname, useRouter } from 'next/navigation'
import styled from 'styled-components'
import Logo from '../Logo'

const HeaderStyled = styled.div`
  position: sticky;
  top: 0px;
  z-index: var(--z-index-9);
  box-shadow: var(--shadow-boxShadow);
  .header__main > .ant-dropdown {
    .ant-btn {
      display: flex;
      justify-content: flex-start;
    }
  }
`
const StyledGrid = styled.header`
  display: grid;
  grid-template-columns: 160px 1fr auto 1fr 160px;
  grid-template-rows: 40px;
  grid-template-areas: 'back . logo . .';
  background-color: var(
    --app-header-background-desktop-v3,
    var(--app-header-background-desktop)
  );
  padding: var(--spacing-padding-small) var(--spacing-padding-xxlarge);
  line-height: normal;

  @media screen and (max-width: 576px) {
    background-color: var(
      --app-header-background-mobile-v3,
      var(--app-header-background-mobile)
    );
    grid-template-rows: 24px;
    grid-column-gap: var(--spacing-margin-small);
    padding: var(--spacing-padding-large);
    width: 100%;
  }
  .header {
    &__back.ant-btn-background-ghost {
      grid-area: back;
      height: 100%;
      border: none;
      box-shadow: none;
      display: flex;
      align-items: center;
      gap: 6px;
      color: var(--app-header-color-desktop-v3, var(--color-white));
      background-color: transparent;

      &:hover,
      &:not(:disabled):hover,
      &:focus,
      &:active {
        color: var(--app-header-color-desktop-v3, var(--color-white));
      }
      @media screen and (max-width: 576px) {
        color: var(--app-header-color-mobile-v3, var(--color-white));
        &:hover,
        &:not(:disabled):hover,
        &:focus,
        &:active {
          color: var(--app-header-color-mobile-v3, var(--color-white));
        }
      }
    }

    &__logo {
      grid-area: logo;
      max-height: 40px;
      cursor: pointer;
      @media screen and (max-width: 576px) {
        display: none;
      }
    }
  }
`
const SimpleHeader = () => {
  const {
    header,
    domain,
    seoConfig: { name = '' } = {},
    clientId,
  } = UseClientModelContext()
  const { simpleHeader: copy } = getLocale() || {
    simpleHeader: {
      placeholder: '',
    },
  }
  const router = useRouter()

  const onClickLogo = async () => {
    trackEvent({
      eventName: 'header_logo',
      clientId,
    })
    await goToHomeHybridMod(router)
  }
  const pathname = usePathname()
  const simpleViewOptions = getSimpleViewOptions({
    copy,
    router,
    pathname,
  })

  const _domain = domain || (isSSR() ? '' : window.location.origin) || ''

  return (
    <HeaderStyled id="header-container" className="header-container">
      <StyledGrid className="header">
        {simpleViewOptions.displayBackButton && (
          <Button
            className="header__back ant-btn-background-ghost"
            onClick={simpleViewOptions.onClickBack}
          >
            <Icon className="ph-caret-left" size={24} />
            <div className="header__back-text">
              {simpleViewOptions.textBackButton}
            </div>
          </Button>
        )}
        <Logo
          className="header__logo"
          src={header.logo}
          slug={name}
          domain={_domain}
          onClick={onClickLogo}
          height={40}
        />
      </StyledGrid>
    </HeaderStyled>
  )
}

export default SimpleHeader
